import { TextField } from '@refinedev/antd'
import { Table } from 'antd'
import { useTranslation } from 'react-i18next'
import { I18N_FORM_NS } from '../../../i18n'
import { css } from '@emotion/css'
import { getLocalizedValue, normalizeReportForDisplay } from '../../../utils/reporting'
import { formatPeriod, getPeriodStart, getPeriodType } from '../../../utils/period'

const textAreaFields = [
	'valuation',
	'investment_events',
	'cash_in_the_bank',
	'burn_rate',
	'run_way',
	'revenue',
	'ebitda',
	'mrr',
	'key_metrics'
]

export const ReportTable = ({ tableProps }) => {
	const { t } = useTranslation([I18N_FORM_NS])

	const columns = [
		{
			title: t('fields.period'),
			dataIndex: 'period_start',
			width: 140,
			fixed: true,
			render: (_, record) => <TextField value={formatPeriod(getPeriodStart(record), getPeriodType(record))} />
		},
		...textAreaFields.map(field => ({
			title: t(`fields.${field}`),
			dataIndex: field,
			width: 120,
			render: value => (
				<TextField
					title={getLocalizedValue(value)}
					value={getLocalizedValue(value)}
					className={css({
						display: '-webkit-box',
						WebkitLineClamp: 4,
						WebkitBoxOrient: 'vertical',
						overflow: 'hidden',
						textOverflow: 'ellipsis'
					})}
				/>
			)
		}))
	]

	const reports = (tableProps?.dataSource ?? []).map(normalizeReportForDisplay)

	return <Table rowKey='id' columns={columns} {...tableProps} dataSource={reports} pagination={false} bordered />
}
